import { SearchInput } from '../shared';
import { SortOrder, ContactTypeSortType } from '../enums';

export class GetContactTypesInput extends SearchInput<ContactTypeSortType> {
    constructor() {
        super(ContactTypeSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
